export const applyCriteriaFilter = (dbQuery: any, remainingTerms: string[]) => {
  if (remainingTerms.length === 0) return dbQuery;
  
  console.log('Applying additional general criteria:', remainingTerms);
  
  const criteriaConditions: string[] = [];
  
  remainingTerms.forEach(term => {
    // Coastal/beach terms
    if (['kust', 'strand', 'zee', 'coast', 'beach', 'adriatic'].some(keyword => term.includes(keyword))) {
      criteriaConditions.push(
        `region.ilike.%${term}%`,
        `region.ilike.%kust%`,
        `city.ilike.%${term}%`,
        `name.ilike.%${term}%`,
        `description.ilike.%${term}%`,
        `description.ilike.%kust%`,
        `description.ilike.%zee%`,
        `description.ilike.%strand%`
      );
    }
    // Family-friendly terms
    else if (['kinderen', 'gezin', 'familie', 'family', 'kids'].some(keyword => term.includes(keyword))) {
      criteriaConditions.push(
        `name.ilike.%gezin%`,
        `name.ilike.%familie%`,
        `name.ilike.%kinderen%`,
        `description.ilike.%gezin%`,
        `description.ilike.%familie%`,
        `description.ilike.%kinderen%`,
        `description.ilike.%family%`,
        `description.ilike.%kids%`,
        `facilities.ilike.%kinderclub%`,
        `facilities.ilike.%kids club%`,
        `facilities.ilike.%speeltuin%`,
        `facilities.ilike.%kindergebeuren%`,
        `specialCategories.ilike.%gezin%`,
        `specialCategories.ilike.%familie%`,
        `typeVakantie.ilike.%gezin%`,
        `typeVakantie.ilike.%familie%`
      );
    }
    // All inclusive terms
    else if (['all', 'inclusive', 'alles', 'inbegrepen'].some(keyword => term.includes(keyword))) {
      criteriaConditions.push(
        `name.ilike.%all inclusive%`,
        `description.ilike.%all inclusive%`,
        `description.ilike.%alles inbegrepen%`,
        `specialCategories.ilike.%all inclusive%`,
        `typeVakantie.ilike.%all inclusive%`
      );
    }
    // Other general terms
    else {
      criteriaConditions.push(
        `name.ilike.%${term}%`,
        `description.ilike.%${term}%`,
        `facilities.ilike.%${term}%`,
        `specialCategories.ilike.%${term}%`,
        `typeVakantie.ilike.%${term}%`
      );
    }
  });
  
  if (criteriaConditions.length > 0) {
    return dbQuery.or(criteriaConditions.join(','));
  }
  
  return dbQuery;
};
